import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCGWHbiAy6kBunHOUYveoLo8bY0Cs3Gjd4",
  authDomain: "task-manager-d2865.firebaseapp.com",
  projectId: "task-manager-d2865",
  storageBucket: "task-manager-d2865.firebasestorage.app",
  messagingSenderId: "186354243543",
  appId: "1:186354243543:web:2b41baa16cc3736f931d92",
  measurementId: "G-KP1X76MKQR",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
